if (!customElements.get('product-content')) {
  customElements.define('product-content', class ProductContent extends HTMLElement {
    constructor() {
      super();
      this.handleBuyTools();
      this.handleCollapsibleBlocks();
      this.handleResponsiveLayout();
    }

    handleBuyTools() {
      const productPageSection = document.querySelector('.product-page-section');
      if (!productPageSection) return;

      const isWrapped = productPageSection.closest('.product-section-main-wrap');
      const productInformation = productPageSection.querySelector('product-information');
      const productInfoWraper = productPageSection.querySelector('.product__info-wrapper');
      const nextElement = productPageSection ? productPageSection.nextElementSibling : null;
      const productContentIsNextSibling = nextElement ? nextElement.classList.contains('product-content-section') : false;

      if (productInfoWraper && productContentIsNextSibling) {
        if (!isWrapped) {
          const templateProduct = this.closest('.template-product-wrapper');
          const walletButton = templateProduct ? templateProduct.querySelector('.wallet-button-fade-in') : null;
          if (walletButton) walletButton.innerHTML = '';
          $('.product-section').wrapAll('<div class="product-section-main-wrap" />');
        }

        productPageSection.classList.add('product-static-buy-tools');

        if (productInformation) {
          window.removeEventListener('scroll', productInformation.onScrollToolsHandler, false);
          productInformation.resizeProductInfoObserver?.disconnect();
          productInformation.staticBuyTools = true;
          productInformation.productInfoContainer?.classList.remove(
            'product__info-container--modal',
            'product__info-container--modal--out',
            'background-modal'
          );
        }

        const productContentSection = document.querySelector('.product-content-section');
        productContentSection?.style.removeProperty('min-height');
      } else if (productInfoWraper && !productContentIsNextSibling) {
        productPageSection.classList.add('product-static-buy-tools');
        if (productInformation) {
          window.removeEventListener('scroll', productInformation.onScrollToolsHandler, false);
          productInformation.resizeProductInfoObserver?.disconnect();
          productInformation.staticBuyTools = true;
        }
      }
    }

    handleResponsiveLayout() {
      const productContentSection = this.closest('.product-content-section');
      const productPageSection = document.querySelector('.product-page-section');
      const leftColumn = productPageSection?.querySelector('.product-layout__left-column');
      const productInfoWrapper = productPageSection?.querySelector('.product__info-wrapper');
      const productInfoContainer = productInfoWrapper?.querySelector('.product__info-container');
      const contentDetails = productContentSection?.querySelector('.product-single__content-details');

      if (
        !productContentSection
        || !productPageSection
        || !leftColumn
        || !productInfoWrapper
        || !productInfoContainer
        || !contentDetails
      ) return;

      const asideItems = Array.from(contentDetails.children).filter(item => {
        return item.matches?.(
          '.product-single-features, .product-single__content-details__item--collapsible'
        ) || item.querySelector?.('.social-sharing');
      });
      const asidePlacements = asideItems.map(item => {
        const marker = document.createComment('product-content-original-position');
        item.before(marker);
        return { item, marker };
      });

      const desktopLayout = window.matchMedia('(min-width: 1001px)');
      const arrangeLayout = () => {
        if (desktopLayout.matches) {
          if (productContentSection.parentElement !== leftColumn) {
            leftColumn.append(productContentSection);
          }
          let aside = productInfoWrapper.querySelector('[data-product-content-aside]');
          if (!aside) {
            aside = document.createElement('div');
            aside.className = 'product-content__aside';
            aside.dataset.productContentAside = '';
            productInfoContainer.insertAdjacentElement('afterend', aside);
          }
          asideItems.forEach(item => aside.append(item));
          productPageSection.classList.add(
            'product-page-section--content-under-gallery',
            'product-page-section--split-content'
          );
        } else {
          asidePlacements.forEach(({ item, marker }) => marker.after(item));
          productInfoWrapper.querySelector('[data-product-content-aside]')?.remove();
          if (productContentSection.previousElementSibling !== productPageSection) {
            productPageSection.insertAdjacentElement('afterend', productContentSection);
          }
          productPageSection.classList.remove(
            'product-page-section--content-under-gallery',
            'product-page-section--split-content'
          );
        }
      };

      arrangeLayout();
      if (desktopLayout.addEventListener) {
        desktopLayout.addEventListener('change', arrangeLayout);
      } else {
        desktopLayout.addListener(arrangeLayout);
      }
    }

    handleCollapsibleBlocks() {
      const details = this.querySelectorAll('.product__collapsible-details');
      const RO = new ResizeObserver(entries => {
        return entries.forEach(entry => {
          const detail = entry.target;
          const detailWidth = +detail.dataset.width;
          const roundedEntrySize = Math.round(entry.contentRect.width);
          if (detailWidth !== roundedEntrySize) {
            detail.removeAttribute('style');
            this.setHeight(detail);
          }
        })
      });

      details.forEach(detail => {
        RO.observe(detail);
      });
    }

    setHeight (detail) {
      detail.open = true;
      const rectOpen = detail.getBoundingClientRect();
      detail.style.setProperty('--expanded', `${rectOpen.height}px`);

      detail.open = false;
      const rectClose = detail.getBoundingClientRect();
      detail.style.setProperty('--collapsed', `${rectClose.height}px`);
      detail.dataset.width = Math.round(rectClose.width);
    }
  });
}
